const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/forms/$formId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type Form_Single_Query$data } from '@/graphql/queries/Form.query';
import { createFileRoute } from '@tanstack/react-router';
import { type FormBodyProps } from './-form-page/FormBody';
type FormEditProps = {
  znglyForm?: Form_Single_Query$data['form'];
  isFallback?: boolean;
};

/**
 * Form Editing Logic
 */

export const Route = createFileRoute('/dash/crm/forms/$formId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});